import { combineReducers } from "redux";
//! Common Reducers
// Layouts
import LayoutReducer from "./layouts/reducer";
// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
// Tasks
import TasksReducer from "./tasks/reducer";
import UserInfoReducer from "./user/reducer";
// Translations
import TranslationReducer from "./translation/reducer";

//! Partner Reducers
// Dashboard
import DashboardReducer from "./dashboard/reducer";
// Contracts
import ContractsReducer from "./contracts/reducer";
// Payment
import PaymentReducer from "./payment/reducer";
// Rebates
import RebatesReducer from "./rebates/reducer";
// Reports
import ReportsReducer from "./reports/reducer";

//! Sales Reducers
// Sales Contracts
import SalesContractsReducer from "./salesContracts/reducer";
// Sales Dashboard
import SalesDashboardReducer from "./salesDashboard/reducer";
// Sales Payment
import SalesPaymentReducer from "./salesPayment/reducer";
// Sales Reports
import SalesReportsReducer from "./salesReports/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Tasks: TasksReducer,
  Dashboard: DashboardReducer,
  SalesDashboard: SalesDashboardReducer,
  Reports: ReportsReducer,
  SalesReports: SalesReportsReducer,
  Contracts: ContractsReducer,
  SalesContracts: SalesContractsReducer,
  Rebate: RebatesReducer,
  Payment: PaymentReducer,
  SalesPayment: SalesPaymentReducer,
  UserInfo: UserInfoReducer,
  Translation: TranslationReducer,
});

export default rootReducer;